import type { IconData } from '@stacksjs/iconify-core'

export const textFormattingHeaderImage: IconData = {
  "body": "<path fill=\"currentColor\" d=\"M16 0H0v11.5h16zm-2 16H2v-2.5h12z\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export default textFormattingHeaderImage
